<template>
 <page>
   
    <head-nav :title="$t('language.latest_calendar')">
      <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

    <scroll-page :pull-reload="true">
   

   <page-padding>
      <button-action v-if="computeUserAccess" :to="'/calendar/0/add_item/'" title="language.add_calendar_item" ></button-action>
   </page-padding>

    <list-calendar/>

     </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ListCalendar from '../components/calendar/ListCalendar';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';


export default {
  name: 'global-calendar-page',
  data:function(){
    return{
    }
  },
  computed:{
     ...mapState([
       'appSettings'
       ]),
       computeUserAccess(){
         
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }

         return false;
       }
  },
  components: {
    PagePadding,
    ButtonAction,
    ListCalendar,
    Page,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    ScrollPage,
  },
  methods:{
    
  },// methods{}
  created(){
    
  },
  mounted(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
